import { createStore } from '@didi/es-mpx-creator'

import actions from './action'
import getters from './getter'
import mutations from './mutation'
import state from './state'

const flightsStore = createStore({
  state,
  getters,
  mutations,
  actions
})

export default flightsStore